import {
  CustomContentItemParams,
  CustomContentItemEntity,
} from "@shared/services/event_tracking/entities/custom_content/custom_content_item_entity";

import type { CustomContentProductListLayoutTypes } from "@shared/types/CustomContent";

interface CustomContentProductListParams extends CustomContentItemParams {
  layout: CustomContentProductListLayoutTypes;
}

export class CustomContentProductListEntity extends CustomContentItemEntity {
  layout: CustomContentProductListLayoutTypes;

  constructor(params: CustomContentProductListParams) {
    super(params);
    this.layout = params.layout;
    this.type = "custom_content_product_list";
    this.entity_version = 3;
  }
}
